// react
// dependencies
import { Map } from "immutable";
import PropTypes from "prop-types";
import React from "react";

export default class Job extends React.PureComponent {
	static propTypes = {
		job: PropTypes.instanceOf(Map).isRequired,
	};

	render() {
		/*
            Job shape:

            error_count     : INT
            finished        : BOOL
            has_progress    : BOOL
            progress_count  : INT
            progress_total  : INT
            senn            : BOOL
            started         : BOOL
            task_id         : STR
            title           : STR
            type            : STR
            _id             : MONGOID
        */

		const { job } = this.props;

		return (
			<div className="job">
				<div>
					<div className="job-status">
						<div className="status-dot" />
					</div>
					<div className="job-label">{job.get("title")}</div>
				</div>
			</div>
		);
	}
}
